import { Control, FieldValues } from 'react-hook-form';
import { ControlledTextField } from '../../../../controlled/ControlledTextField';

type FeedbackProps<T extends FieldValues> = {
  control: Control<T>;
} & FieldValues;

export const Feedback = <T extends FieldValues>({ control }: FeedbackProps<T>) => {
  return (
    <ControlledTextField
      control={control}
      fieldName="text"
      placeholder="Your feedback"
      multiline
      minRows={3}
      notRequired
    />
  );
};
